import GradientSection from './GradientSection'

export default GradientSection
